/* @flow */
import { rem } from 'polished';
import { baseFontSize } from '@braindate/ui/lib/token/typography';

import { hoverSelector } from 'src/shared/app/base/style/token/selector';
import type {
  ThemeFunction,
  Theme,
} from 'src/shared/app/base/types/themeTypes';
const mergeStyles = ({
  theme,
  withSuccess,
  isPrimary,
  customColor,
  ariaDisabled,
}: {
  theme: Theme,
  withSuccess: boolean,
  isPrimary: boolean,
  customColor: string,
  ariaDisabled: boolean,
}) => {
  if (isPrimary) {
    return getPrimaryStyles({ theme, withSuccess, ariaDisabled });
  }
  return getSecondaryStyles({ theme, withSuccess, customColor, ariaDisabled });
};

const getPrimaryStyles = ({ theme, withSuccess, ariaDisabled }: Object) => ({
  backgroundColor: withSuccess ? theme.successTextColor : theme.accentColor,
  color: theme.textColorReverse,
  border: `solid 1px ${
    withSuccess ? theme.successTextColor : theme.accentColor
  }`,
  opacity: ariaDisabled ? 0.5 : 1,
  [hoverSelector]: {
    boxShadow: theme.buttonShadowBox,
    textDecoration: 'none',
  },
});

const getSecondaryStyles = ({
  theme,
  withSuccess,
  customColor,
  ariaDisabled,
}: Object) => ({
  backgroundColor: withSuccess ? theme.successTextColor : 'transparent',

  border: `solid 1px ${withSuccess ? theme.successTextColor : customColor}`,
  color: withSuccess ? theme.textColorReverse : customColor,
  fill: customColor,
  stroke: customColor,
  opacity: ariaDisabled ? 0.5 : 1,

  [hoverSelector]: {
    backgroundColor: withSuccess ? theme.successTextColor : customColor,
    color: theme.textColorReverse,
  },
  '&:active': {
    backgroundColor: 'transparent',
  },
});

export default {
  root: ({
    theme,
    withSuccess,
    isPrimary,
    customColor,
    ariaDisabled,
  }: ThemeFunction<{
    withSuccess: boolean,
    isPrimary: boolean,
    customColor: string,
    ariaDisabled: boolean,
  }>) => ({
    textTransform: 'uppercase',
    fontSize: rem(12, baseFontSize),
    ...mergeStyles({
      theme,
      withSuccess,
      isPrimary,
      customColor,
      ariaDisabled,
    }),
  }),

  'root-withError': {
    color: ({ theme }: ThemeFunction) => theme.errorMessageColor,
    borderColor: ({ theme }: ThemeFunction) => theme.errorMessageColor,
    '&:hover': {
      backgroundColor: ({ theme }: ThemeFunction) => theme.errorMessageColor,
    },
  },
};
